import { render, staticRenderFns } from "./unsign.vue?vue&type=template&id=71a4dc0c"
import script from "./unsign.vue?vue&type=script&lang=js"
export * from "./unsign.vue?vue&type=script&lang=js"
import style0 from "./unsign.vue?vue&type=style&index=0&id=71a4dc0c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports